export const removeTrailingSlash = (url: string) => {
  if (url.charAt(url.length - 1) === '/') {
    return url.substring(0, url.length - 1);
  }

  return url;
};
